import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import EnTranslation from '../locales/en/translation.json';
import TrTranslation from '../locales/tr/translation.json';

const resources = {
    en: {
        translation: EnTranslation
    },
    tr: {
        translation: TrTranslation
    }
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'tr'],
    resources,
    fallbackLng: 'tr',
    debug: false,
    detection: {
      order: ['path', 'cookie', 'htmlTag'],
      caches: ['cookie'],
    },
    react: { useSuspense: false },
  });